/* eslint-disable react/prop-types */
import React from 'react';

// 📌 Componentes compartidos
import {
  Portlet,
  PortletContent,
  PortletHeader,
  PortletLabel,
} from 'components';

import { useIntl } from 'react-intl';
import { Box, Typography } from '@mui/material';

export default function ChargeWithMostConsumeChart({ chargeMostConsume }) {
  const intl = useIntl();

  // 🛑 Si no hay datos, no renderizamos nada
  if (!chargeMostConsume) return null;

  return (
    <Portlet>
      {/* 🏷️ Encabezado con el título */}
      <PortletHeader noDivider={true}>
        <PortletLabel
          title={intl.formatMessage({
            id: 'app.meter.board.chargeHighestConsumMonth.title',
          })}
        />
      </PortletHeader>

      {/* 📊 Contenido con los detalles del cargo de mayor consumo */}
      <PortletContent
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          paddingTop: 0,
          alignItems: 'center',
        }}
      >
        {/* ⚡ Nombre del cargo */}
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="h5">
            {intl.formatMessage({
              id: 'app.meter.board.chargeHighestConsumMonth.charge',
            })}
          </Typography>
          <Typography sx={{ fontWeight: 'normal' }} variant="h4">
            {chargeMostConsume.charge_name}
          </Typography>
        </Box>

        {/* 🏢 Grupo al que pertenece */}
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="h5">
            {intl.formatMessage({
              id: 'app.meter.board.chargeHighestConsumMonth.group',
            })}
          </Typography>
          <Typography sx={{ fontWeight: 'normal' }} variant="h4">
            {chargeMostConsume.group_name}
          </Typography>
        </Box>

        {/* 🔌 Consumo total en kWh */}
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="h5">
            {intl.formatMessage({
              id: 'app.meter.board.chargeHighestConsumMonth.consumption',
            })}
          </Typography>
          <Typography sx={{ color: '#730065' }} variant="h4">
            {chargeMostConsume.total_kwh
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{' '}
            kWh
          </Typography>
        </Box>

        {/* 💰 Monto total */}
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="h5">
            {intl.formatMessage({
              id: 'app.meter.board.chargeHighestConsumMonth.amount',
            })}
          </Typography>
          <Typography sx={{ color: '#45B880' }} variant="h4">
            ${' '}
            {chargeMostConsume.total_money
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          </Typography>
        </Box>
      </PortletContent>
    </Portlet>
  );
}
